import { render } from "./MeasureExplanation.vue?vue&type=template&id=010f5f92&scoped=true"
import script from "./MeasureExplanation.vue?vue&type=script&lang=js"
export * from "./MeasureExplanation.vue?vue&type=script&lang=js"

import "./MeasureExplanation.vue?vue&type=style&index=0&id=010f5f92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010f5f92"]])

export default __exports__